import { images } from './images';

export type Certification = {
  id: string;
  name: string;
  appliesTo: string;
  logo?: string;
  mark?: string;
  text: string;
  principles: string[];
};

export const certifications: Certification[] = [
  {
    id: 'ecocert',
    name: 'Ecocert',
    appliesTo: 'Organisme de contrôle',
    logo: images.ecocert,
    text: 'ECOCERT est un organisme de contrôle et de certification fondé en France en 1991. Ecocert a été le tout premier organisme de certification à développer un référentiel pour les « Cosmétiques écologiques et biologiques » en 2002.',
    principles: ['Protéger la planète', 'Réduire les déchets', 'Informer les utilisateurs', 'Contrôle et certification'],
  },
  {
    id: 'cosmos',
    name: 'Bio-Cosmos Organic',
    appliesTo: 'Nos cosmétiques',
    logo: images.cosmebio,
    text: 'Au-delà du pourcentage de naturalité et d’origine biologique minimum requis, les cosmétiques bio labellisés s’inscrivent dans une démarche éthique globale.',
    principles: ['Chimie verte', 'Communication transparente', 'Respect du travailleur'],
  },
  {
    id: 'ab',
    name: 'Agriculture Biologique Europe',
    appliesTo: 'Nos compléments alimentaires',
    mark: 'AB',
    text: 'Nos compléments alimentaires sont certifiés Agriculture Biologique Europe, avec des garanties fortes pour l’environnement et le consommateur.',
    principles: [
      'Protection de l’environnement et du climat',
      'Conservation de la fertilité des sols',
      'Maintien de la biodiversité',
      'Respect des cycles naturels et du bien-être animal',
      'Aucun produit chimique de synthèse ni OGM',
      'Étiquetage transparent',
    ],
  },
];
